/** Hero stage: the artist link, a finished lyric video and its label. */
export default function LyricVideoDemo() {
  return (
    <div className="w-[min(610px,100%)]">
      <a
        href="/@ozwaldbozwald"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="View Ozwald Bozwald's Lutely profile"
        className="group mb-3 flex w-full items-center gap-[11px] font-figtree text-[15px] font-extrabold leading-[1.2] text-white"
      >
        <img
          src="/marketing/lyric-video/ozwald-bozwald-avatar.webp"
          alt="Ozwald Bozwald"
          width={38}
          height={38}
          className="size-[38px] shrink-0 rounded-full border border-white/[0.34] object-cover"
        />
        <span className="underline-offset-4 group-hover:underline">
          Ozwald Bozwald - LIFE
        </span>
      </a>
      <div className="aspect-video w-full overflow-hidden rounded-[22px] border border-white/[0.28] bg-[rgba(2,7,30,0.58)]">
        <video
          controls
          playsInline
          preload="metadata"
          poster="/marketing/lyric-video/life-lyric-video-poster.webp"
          aria-label="Finished Lutely lyric video"
          className="block size-full object-cover"
        >
          <source
            src="/marketing/lyric-video/life-lyric-video.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <p className="mt-[11px] w-full text-center font-figtree text-[11px] font-extrabold uppercase leading-[1.2] tracking-[0.14em] text-white/[0.58]">
        Real product demo
      </p>
    </div>
  );
}
